var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: `${_vm.charHeight}px`, width: '100%' }),attrs:{"id":"main"}})
}
var staticRenderFns = []

export { render, staticRenderFns }